import { catchError, finalize, tap } from 'rxjs';
import { DocumentTemplate, DownloadTemplateGQL } from '@iss/libs/graphql';
import { Component, inject, Input } from '@angular/core';

import { DownloadTemplateSkeletonComponent } from '../download-template-skeleton';

import { downloadFile } from '@iss/wo-common/utils';
import { ToastService } from '@iss/core/portal';

@Component({
  selector: 'wo-download-template',
  templateUrl: './download-template.component.html',
  styleUrls: [ './download-template.component.scss' ],
  standalone: true,
  imports: [
    DownloadTemplateSkeletonComponent,
  ],
})
export class DownloadTemplateComponent {
  private readonly query = inject(DownloadTemplateGQL);
  private readonly toast = inject(ToastService);

  public loading = false;

  @Input({ required: true }) template!: DocumentTemplate;

  public download(): void {
    this.query.watch({ template: this.template }).valueChanges.pipe(
      tap(({ data, loading, error }) => {
        this.loading = loading;
        if (error) {
          throw error;
        } else if (data) {
          downloadFile(data.downloadTemplate.url);
        }
      }),
      catchError(e => {
        this.toast.error('The template could not be downloaded. Try again later.', { withoutTranslation: true });
        throw e;
      }),
      finalize(() => {
        this.loading = false;
      }),
    ).subscribe();
  }
}
